<template>
  <div>
    <!-- Header -->
    <div class="im2u-login-page">
      <b-row>
        <b-col cols="12" md="6" class="left-side py-5 py-md-0">
            <b-row align-v="center" class="h-100">
              <b-col cols="12" class="d-flex justify-content-center">
                <b-img src="/img/stock_broker.png" fluid alt="Login Image"></b-img>
              </b-col>
            </b-row>
        </b-col>
        <b-col cols="12" md="6" class="right-side py-5 py-md-0">
          <b-row align-v="center" align-h="center" class="h-100">
            <b-col cols="12" class="d-flex justify-content-center mb-md--8">
              <div>
                <b-img src="/img/brand/logo_im2u.png" fluid alt="Login IM2U Logo"></b-img>
                <h1 class="display-1 font-weight-bold mb-0">
                  <div class="text-center" v-if="APP_MODE !== 'production'">
                    <span class="badge d-inline-block badge-warning">{{APP_MODE.toUpperCase()}}</span>
                  </div>
                </h1>
              </div>
            </b-col>
            <b-col cols="10" md="6" class="mt-5 mt-md--8">
              <div class="mb-3">
                <p class="text-danger mb-0" v-show="auth_erorr" v-text="auth_erorr"></p>
                <p>Please sign in with credentials.</p>
              </div>
              
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <b-form-input alternative
                              class="mb-3"
                              name="Email"
                              :rules="{required: true, email: true}"
                              prepend-icon="ni ni-email-83"
                              placeholder="Email"
                              type="email"
                              v-model="model.email">
                  </b-form-input>
                  <b-input-group class="mb-3">
                    <template #append>
                      <b-input-group-text>
                        <a href="javascript:void(0)" @click="is_show_password = !is_show_password">
                          <b-icon :icon="!is_show_password ? 'eye': 'eye-slash'" class="text-muted"></b-icon>
                        </a>
                      </b-input-group-text>
                    </template>
                      <b-form-input alternative
                                name="Password"
                                :rules="{required: true, min: 8}"
                                :type="is_show_password ? 'text' : 'password'"
                                placeholder="Password"
                                v-model="model.password"
                                class="border-right-0"
                      >
                    </b-form-input>
                  </b-input-group>

                  <b-form-checkbox v-model="model.rememberMe">Remember me</b-form-checkbox>
                  <div class="text-center mt-3">
                    <el-button class="bg-primary text-white w-full" native-type="submit" :loading="is_loading">Sign in</el-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
.input-group:focus-within .input-group-prepend .input-group-text,
.form-control:focus ~ .input-group-append .input-group-text {
  border-color: #06f;
}
</style>
<script>
  import { useAuthStore } from '@/stores/authStore';
  import { useKycStore } from '@/stores/kycStore';
  import { mapActions, mapState } from 'pinia'
  import { APP_MODE } from '@/assets/js/config.js'
  import { Button } from 'element-ui'
  import {
    helperFunctionMixin,
    notifyFunctionMixin,
  } from '@/assets/js/httpImports.js'
  export default {
    mixins: [helperFunctionMixin],
    components: {
      [Button.name]: Button,
    },
    data() {
      return {
        model: {
          email: '',
          password: '',
          rememberMe: false,
        },
        demo: process.env.DEMO || false,
        APP_MODE: APP_MODE,
        is_show_password: false,
        is_loading:false
      };
    },
    computed: {
      ...mapState(useAuthStore, ['auth_loading', 'auth_erorr', 'auth_user'])
    },
    mounted: function (){
      console
    },
    methods: {
      ...mapActions(useAuthStore, ['login']),
      ...mapActions(useKycStore, ['kycLogin']),
      async onSubmit() {        
        this.is_loading = true
        await this.login(this.model.email, this.model.password)
        // if(this.checkAppCode('consfield'))
        // {
        //   this.kycLogin(this.model.email, this.model.password)
        // }
        this.is_loading = false

        if(this.auth_user){
          this.$router.push('/leadsListings')
        }
      },
    }
  };
</script>
